module.exports = __webpack_public_path__ + "img/cobas.04a07f61.png";